import { useQuery } from '@tanstack/react-query';
import impersonationApi from '@/api/impersonationApi';

export const IMPERSONATION_QUERY_KEY = ['impersonation'];

export function useCanImpersonate(enabled: boolean = true) {
  return useQuery({
    queryKey: [...IMPERSONATION_QUERY_KEY, 'can-impersonate'],
    queryFn: impersonationApi.canImpersonate,
    staleTime: 5 * 60 * 1000, // 5 minutes - doesn't change often
    enabled,
  });
}

export function useImpersonationUsers(enabled: boolean = true) {
  return useQuery({
    queryKey: [...IMPERSONATION_QUERY_KEY, 'users'],
    queryFn: impersonationApi.getUsers,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled,
  });
}
